import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils.js";

const GHOST_ROWS = [
  { name: "John Doe", phone: "+1 ··· ··· ····", statusKey: "delivered" as const },
  { name: "Olivia Carter", phone: "+1 ··· ··· ····", statusKey: "read" as const },
  { name: "Alex Rivera", phone: "+1 ··· ··· ····", statusKey: "delivered" as const },
];

export function CampaignPrelaunchIllustration({
  compact = false,
}: {
  compact?: boolean;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className={cn("relative mx-auto grid w-full max-w-sm gap-2", compact ? "max-w-xs" : "max-w-sm")}
      aria-hidden="true"
      data-testid="campaign-prelaunch-ghost"
    >
      {GHOST_ROWS.map((row, index) => (
        <div
          key={row.name}
          className={cn(
            "flex items-center justify-between gap-3 rounded-xl border border-line/60 bg-surface px-3 py-2 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)]",
            "animate-campaign-ghost-float motion-reduce:animate-none",
            index === 0 && "opacity-70 delay-0",
            index === 1 && "opacity-45 blur-[0.3px] delay-150",
            index === 2 && "opacity-25 blur-[0.6px] delay-300",
          )}
        >
          <div className="grid min-w-0 gap-0.5 text-start">
            <span className="truncate text-[0.8125rem] font-semibold text-foreground">{row.name}</span>
            <span className="truncate font-mono text-[0.6875rem] text-muted" dir="ltr">
              {row.phone}
            </span>
          </div>
          <span
            className={cn(
              "shrink-0 rounded-full px-2 py-0.5 text-[0.6875rem] font-medium",
              row.statusKey === "read"
                ? "bg-success-muted text-success"
                : "bg-accent/10 text-accent",
            )}
          >
            {row.statusKey === "read"
              ? t("campaigns.prelaunch.ghostRead")
              : t("campaigns.prelaunch.ghostDelivered")}
          </span>
        </div>
      ))}
    </div>
  );
}
